import ReactDOM from 'react-dom/client'
import App from 'src/App'
import 'src/index.less'
import { Auth0Provider } from '@auth0/auth0-react'
import { appConfig } from 'src/config/app.config'
import { ErrorBoundary } from './pages/error/ErrorBoundary'
import { initialiseSentry } from './utils/common.utils'

initialiseSentry()

ReactDOM.createRoot(document.getElementById('root')!).render(
    //@ts-ignore
    <ErrorBoundary>
        <Auth0Provider
            domain={appConfig.sso.domain}
            clientId={appConfig.sso.clientId}
            authorizationParams={{ redirect_uri: window.location.origin }}
        >
            <App />
        </Auth0Provider>
    </ErrorBoundary>
)
